module.exports = __webpack_public_path__ + "img/dea-formazione-ico-ddi.e0950840.svg";